<template>
  <div id="dlnk-contacts" class="container-fluid">

    <div class="">
        <div class="bg-primary" style="background-image: url({$img_dir}+ 'components/abstract-shapes-20.svg');">
          <div class="container space-1 space-top-lg-2 space-bottom-lg-2">
            <div class="row d-flex justify-content-between align-items-center px-3">
              <h1 class="col-md-5 col-12 text-white text-center text-md-left">Liste des membres</h1>

              <div class="col-md-7 row d-flex align-items-center justify-content-end">
                <!--<button type="button" class="col-4 btn btn-light btn-block btn-lg"><i class="fa fa-filter mr-2"></i>Trier par</button>-->

                <div class="col-8 pr-0 js-focus-state input-group input-group-sm h-15">
                  <div class="input-group-prepend">
                        <span class="input-group-text">
                            <span class="fas fa-search"></span>
                        </span>
                  </div>
                  <input type="text" id="search_text" name="search_text" class="form-control" v-model="query" placeholder="Rechercher un membre">
                  <span v-if="search_message.length > 5" class="form-text text-danger d-block">{{ search_message }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container space-1">

          <div class="content_sortPagiBar mb-3">
            <div class="clearfix">
              <!-- Pagination -->
              <dlnkpagination
                  :page="page"
                  :page_count="page_count"
                  @next_page="next_page()"
                  @prev_page="prev_page()"
                  @set_page="set_page($event)">
              </dlnkpagination>
              <!-- End Pagination -->
            </div>
          </div>

          <div class="row">
            <div v-for="contact in contacts" :key="contact.id_customer" class="col-sm-6 col-lg-3 px-2 mb-3">

              <div v-if="contact.has_profile && contact.has_profile.length > 3" class="modal fade" :id="'profil_modal-' + contact.id_customer" tabindex="-1"
                   role="dialog" :aria-labelledby="'profil_modal_label_' + contact.id_customer">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title" :id="'profil_modal_label_' + contact.id_customer">Profil de {{contact.name}}</h4>
                      <button type="button" class="close" data-dismiss="modal"
                              aria-label="Close"><span
                          aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <embed style="min-height:60vh;width:100%"
                             :src="'/module/datools/getcustomerprofile?ref=' + contact.customer_reference"/>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" data-dismiss="modal">
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal -->
              <div class="modal" id="REMOVEcontactDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                  <div class="modal-content">
                    <div class="modal-header py-2">
                      <img src="{$img_dir}/100x100/img3.jpg" class="avatar avatar-md avatar-circle mr-4">
                      <h5 class="modal-title">
                        Nicolas Aires
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body py-4">
                      <p>
                        <span class="font-weight-bold">Statut de membre :</span> Administrateur
                      </p>
                      <p class="font-weight-bold mb-0">
                        Membre des groupes<span class="text-primary"> (groupes en commun)</span> :
                      </p>
                      <ul>
                        <li class="text-primary">Bootcamp 2</li>
                        <li class="text-primary">Ami des animaux</li>
                        <li>Club de Curling</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card h-75 transition-3d-hover">
                <div class="card-header d-flex py-5"
                     v-bind:style="{ backgroundImage: 'url(' + header_images[Math.floor(Math.random()*header_images.length)] + ')' }"
                     style="background-size: cover;"
                     href="#" data-toggle="modal" data-target="#contactDetailsModal">
                    <div class="avatar avatar-lg avatar-circle position-absolute" style="left: 50%;transform: translate(-50%, 0);">
                      <img
                          :src="'/module/datools/getcustomerphoto?ref=' + contact.customer_reference"
                          :alt="'avatar de ' + contact.firstname" class="avatar avatar-lg avatar-circle">
                    </div>
                </div>

                <div class="card-body" href="#" data-toggle="modal" data-target="#contactDetailsModal">
                  <h4 class="text-center mt-4 mb-1">{{contact.name}}</h4>


                  <p class="text-center mb-7"><!--3 groupes en commun--></p>

                </div>

                <div class="card-footer py-2">
                  <div class="d-flex justify-content-center">

                    <!-- Insérer ici le code du partage du profil -->
                    <!--<i class="fas fa-share-alt fa-2x icon-contact-card text-primary"></i>-->

                    <a v-if="contact.has_profile && contact.has_profile.length > 3" href="#" data-toggle="modal"
                       :data-target="'#profil_modal-' + contact.id_customer" data-tooltip="tooltip"
                       title="Voir le CV" class="mr-2 float-right">
                      <i class="fa fa-address-card fa-2x icon-contact-card text-primary"></i>
                    </a>
                    <a :href="'/module/dlnkmeetings/contact?id=' + contact.id_customer" data-tooltip="tooltip"
                       title="Voir le profil" class="float-right">
                      <i class="fa fa-2x fa-id-badge mx-2 icon-contact-card text-primary"></i>
                    </a>
                    <a :href="'/module/dlnkchat/chat?id=' + contact.id_customer" data-toggle="tooltip" title="Commencer une conversation"
                       data-original-title="Commencer une conversation" class="float-right">
                      <i class="fa fa-comments fa-2x icon-contact-card text-primary"></i>
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="content_sortPagiBar mb-3">
            <div class="clearfix">
              <!-- Pagination -->
              <dlnkpagination
                  :page="page"
                  :page_count="page_count"
                  @next_page="next_page()"
                  @prev_page="prev_page()"
                  @set_page="set_page($event)">
              </dlnkpagination>
              <!-- End Pagination -->
            </div>
          </div>
        </div>

    </div>

  </div>
</template>

<script>

export default {
  props: {},

  data: function () {
    return {
      page: 1,
      page_count: 1,
      query: "",
      search_message: "",
      contacts: Array,
      header_images: ['' +
        '/modules/dlnkmeetings/img/random_card_header/abstract1.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract2.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract3.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract4.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract5.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract6.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract7.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract8.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract9.jpg',
        '/modules/dlnkmeetings/img/random_card_header/abstract10.jpg',  ],
    }
  },
  mounted() {
    this.get_data()
  },

  watch: {
    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.search_message = ""
        this.get_data();
      } else if (new_val.length > 0 && new_val.length > old_val.length) {
        this.search_message = "Veuillez saisir au moins 3 caractères pour démarrer la recherche"
      } else {
        this.get_data()
      }
    }
  },

  computed: {
    /* random_image: function() {
      return this.header_images[Math.floor(Math.random()*this.header_images.length)];
    } */
  },

  methods: {
    get_data: function () {
      let _this = this;

      let url = '/modules/dlnkmeetings/actions/contacts.php?page=' + _this.page + '&query=' + _this.query;

      axios.get(url)
          .then(function (response) {
            _this.contacts = response.data.contacts
            _this.contact_count = response.data.contact_count
            _this.page_count = response.data.page_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    getRandomImage: function() {
      this.random_image = this.header_images[Math.floor(Math.random()*this.header_images.length)];
      console.log(this.random_image);
      return true;
    }
  }
}
</script>
